import React from 'react';
import { useTranslation } from 'react-i18next';

const Translator = ({ children }) => {
  const { ready } = useTranslation();

  if (!ready) {
    return null;
  }

  return (
    <>
      {children}
    </>
  );
};

export { Translator };
